import Licensee, { DefaultShippingAddress } from '@/model/licensee.mjs';
import { client } from './backoffice-api';
import Transfer from '@/model/transfer.mjs';
import AppConfig from '@/utils/app-config.mjs';
import StoreDetailsInterface, { TrackingInterface } from '@/model/store.mjs';
import { EditValuesToBeSavedInterface } from '@/model/editDetails.mjs';
import {
  DealerActionTimeout,
  StoreTermsAndConditions,
  UseCreateStoreFormInterface
} from '@/model/profile.mjs';
import { ContactDetail, CustomAddress } from '@/explore/types';
import {
  CreateTransferPayload,
  TransferListCustomParams,
  TransferListResquestParams
} from '@/queue/types';
import {
  CreateUserInterface,
  EditUserInterface,
  PreferredDealersMetaData,
  StoreConfigForm,
  StoreFilterConfig
} from '@/storeAdmin/types';
import { TransferList } from '@/queue/QueueDataSource';
import { GlobalConfig } from '@/review/types';
import { ServicesTypeUpdate } from '@/dealerProfile/edit-dealer-profile/schema';
import { LicenseDetail } from '@/model/builders/ffl-get-license-details.mjs';
import { uploadData } from 'aws-amplify/storage';

export async function LicenseById(first3: string, last5: string) {
  const response = await client.get(
    `${AppConfig.fflGetApiBaseURL}/license/${first3}/${last5}`,
    { timeout: 30000 }
  );
  return response.data[0] as Licensee;
}

export async function createTransfer(params: CreateTransferPayload) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/transfers`,
    params,
    { timeout: 30000 }
  );
  return response.data as Transfer;
}

export async function updateTransferNotesDetail(id: string | undefined, data: { notes: string[] }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/transfer-notes/${id}`,
    data,
    { timeout: 30000 }
  );
  return response.data;
}

export async function updateTransferStatus(params: {
  status: { value: string };
  id: string;
}) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${params?.id}/status`,
    params.status,
    { timeout: 30000 }
  );
  return response.data;
}

export async function createDealerActions(
  data: Array<EditValuesToBeSavedInterface | ServicesTypeUpdate | {
    [socialLinksName: string]: string | null | undefined,
    source: string
    name: string
}>
): Promise<number> {
  console.log('going to call api with data', data)
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/dealers/actions`,
    data,
    { timeout: 30000 }
  );
  return response.status;
}

export async function callCustomWebhookTestConnection(data: {webhookUrl: string}) {
  console.log('going to call api with data', data)
  const response = await client.post(
    `${AppConfig.fflGetApiBaseURL}/webhooks/test-client-connection`,
    data,
    { timeout: 30000, withCredentials: true  }
  );
  console.log("response", JSON.stringify(response))
  return response;
}

export async function callCustomWebhookRotate(data: { url: string }) {
  console.log('going to call api with data', data)
  const response = await client.post(
    `${AppConfig.fflGetApiBaseURL}/webhooks/rotate-webhook-connection`,
    data,
    { timeout: 30000 }
  );
  console.log("response", JSON.stringify(response))
  return response;
}

export async function UpdateCustomWebhookConfiguration(data: {url: string, secret: string}) {
  console.log('going to call update/save api with data', data)
  const response = await client.post(
    `${AppConfig.fflGetApiBaseURL}/webhooks/configuration`,
    data,
    { timeout: 30000  }
  );
  console.log("response", JSON.stringify(response))
  return response;
}

export async function GetCustomWebhookConfiguration() {
  const response = await client.get(
    `${AppConfig.fflGetApiBaseURL}/webhooks/configuration`,
    { timeout: 30000  }
  );
  console.log("GET response", JSON.stringify(response))
  return response;
}

export async function reinitiateTransfer(data: { transferId: string }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/transfers/rerun`,
    data,
    { timeout: 30000 }
  );
  return response.status;
}

export async function getStoreDetails() {
  const response = await client.get(
    `${AppConfig.fflGetStoreApi}/store/profile`,
    { timeout: 30000 }
  );
  return response;
}

export async function putStoreDetails(data: StoreDetailsInterface) {
  const response = await client.put(
    `${AppConfig.fflGetStoreApi}/store/profile`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function putDealerActionTimeout(data: DealerActionTimeout) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/store/config/dealer/action/timeout`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function getDealerActionTimeoutAPI() {
  const response: DealerActionTimeout = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/store/config/dealer/action/timeout`,
    { timeout: 30000 }
  );
  return response;
}

export async function getStoreTermsAndConditions() {
  const response: StoreTermsAndConditions = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/store/config/store/terms-conditions`,
    { timeout: 30000 }
  );
  return response;
}

export async function putStoreTermsAndConditions(
  data: StoreTermsAndConditions
) {
  const response: StoreTermsAndConditions = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/store/config/store/terms-conditions`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function getTranferDetails(data: { id: string }) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${data.id}`,
    { timeout: 30000 }
  );
  return response;
}

export async function getTranferEmailStatusDetails(data: { id: string }) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${data.id}/email-status-history`,
    { timeout: 30000 }
  );
  return response;
}

export async function EZCheckValidator(data: { license_key: string }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/ez-check-validator/${data.license_key}`,
    { timeout: 30000 }
  );
  return response;
}

export async function getEZCheckValidatorHistory(data: {
  license_key: string;
  limit?: number;
}) {
  const { license_key, limit } = data;
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/ez-check-validator/${license_key}/history`,
    { timeout: 30000, ...(limit ? { params: { limit } } : {}) }
  );
  return response;
}

export async function createStore(data: any) {
  const response = await client.post(
    `${AppConfig.fflGetStoreApi}/store/profile`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function updateBlacklistedStatus(payload: {
  data: { isBlacklisted: boolean };
  licenseKey: string;
}) {
  const { data, licenseKey } = payload;
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/dealers/${licenseKey}/preferences`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function uploadCertificateInS3(files: any, storeId: string) {
  const result = await uploadData({
  path: `certificates/${storeId}/${files?.name}`,
  data: files,
  options: {
    contentType: files?.type,
    bucket: "licenseReader"
  }
}).result;

return result;
}

export async function updateLicenseUploadStatus(
  id: string,
  status: string,
  license_key: string
) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/certificate-history/status`,
    {
      id,
      status,
      license_key
    },
    { timeout: 30000 }
  );
  return response;
}

export async function updateLicenseApprovalStatus(
  id: string,
  status: string,
  license_key: string,
  printed_name: string | undefined,
  position_title: string | undefined,
  ocr_expiry_date: string,
  printed_date: string,
  premise_address: string | undefined,
  mailing_address: string | undefined,
  rejected_reason: string | undefined,
  note: string | undefined,
  ignoreManualReviewEmail: boolean
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/certificate-history/status`,
    {
      id,
      status,
      license_key,
      printed_name,
      position_title,
      ocr_expiry_date,
      printed_date,
      premise_address,
      mailing_address,
      rejected_reason,
      note,
      ignoreManualReviewEmail
    }
  );
  return response;
}

export async function toggleCertificateMarkedAsReviewedStatus(id: string) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/certificate-history/status`,
    {
      id,
      status: 'MARKED_AS_REVIEWED'
    }
  );
  return response;
}

/** Gallery "mark / unmark reviewed" for SOT rows — same payload shape as certificate grid toggle. */
export async function toggleSOTMarkedAsReviewedStatus(id: string) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/update-sot-status`,
    {
      id,
      status: 'MARKED_AS_REVIEWED'
    }
  );
  return response;
}

/** Gallery "mark / unmark reviewed" for LOA rows — same payload as SOT toggle. */
export async function toggleLOAMarkedAsReviewedStatus(id: string) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/update-loa-status`,
    {
      id,
      status: 'MARKED_AS_REVIEWED'
    }
  );
  return response;
}

export async function updateSOTTaxStampsStatus(
  payload: any
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/update-sot-status`,
    payload
  );
  return response;
}

export async function updateLOAApprovalStatus(
  payload: any
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/update-loa-status`,
    payload
  );
  return response;
}

export async function updateDealerActionStatusApi(id: string, status: string) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/dealer/actions/status`,
    { id, status },
    { timeout: 30000 }
  );
  return response;
}

export async function downloadMasterProofPdfFile(license_key: string) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/dealer-master-proof/${license_key}`,
    {},
    { timeout: 60000 }
  );
  return response;
}

export async function getLicenseHistory(data: {
  first3: string;
  last5: string;
}) {
  const response = await client.get(
    `${AppConfig.fflGetApiBaseURL}/license-history/${data.first3}/${data.last5}`,
    { timeout: 30000 }
  );
  return response;
}

export async function sendEditProfileEmail(data: { license_key: string }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/send-dealer-profile`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function getTranferStatusWorkflow(data: { id: string, allHistory?: boolean }) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/transfer-status/v2/${data.id}`,
    { timeout: 30000 }
  );
  return response;
}

export interface GetStoreNameListParams {
  orderBy?: unknown[];
  filter?: string[];
  page_size?: number;
  page_number?: number;
  fetch_transfer_counts?: boolean;
}

export async function getStoreNameList(params?: GetStoreNameListParams) {
  const searchParams = new URLSearchParams();
  searchParams.set('orderBy', JSON.stringify(params?.orderBy ?? []));
  (params?.filter ?? []).forEach((f) => searchParams.append('filter[]', f));
  if (params?.page_size) {
    searchParams.set('page_size', String(params.page_size));
  }
  if (params?.page_number) {
    searchParams.set('page_number', String(params.page_number));
  }
  if (params?.fetch_transfer_counts === false) {
    searchParams.set('fetch_transfer_counts', 'false');
  }
  const query = searchParams.toString();
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/admin/stores?${query}`
  );
  return response.data;
}

export async function getDealerStoreDetails(dealerId: string) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/store-details`,
    { params: { dealer_id: dealerId }, timeout: 30000 }
  );
  return response.data;
}

export async function addDealerEvent(payload: {
  license_key?: string
  transfer_id: string
  order_number: string
  store_id?: string
  action: string
  notes: string
}) {
  const body = {
    license_key: payload.license_key ?? '',
    transfer_id: payload.transfer_id,
    order_number: payload.order_number,
    store_id: payload.store_id,
    action: payload.action,
    notes: payload.notes,
  }
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/event-logs`,
    body,
    { timeout: 60000 }
  )
  return response
}

export async function updateEventLogVisibility(payload: { id: number; is_hidden: boolean }) {
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/event-logs`,
    payload,
    { timeout: 60000 }
  )
  return response
}

export async function getSourceDescriptionList() {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/sources`
  );
  return response.data;
}
export async function getStoreFilterConfigData() {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/store/filter/config`
  );
  return response.data;
}
export async function getMasterProofStatus(requestId: string) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/dealer-master-proof/status/${requestId}`,
    { timeout: 60000 }
  );
  return response;
}

export async function removeLicense(data: { license_key: string, type: string }) {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/certificates/${data.license_key}/${data.type}`,
    { timeout: 30000 }
  );
  return response;
}

export async function refreshSerpEnrichmentApi(data: { license_key: string }) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/serp-enrichment?license_key=${data?.license_key}`,
    { timeout: 30000 }
  );
  return response;
}

export async function createContactDetails(payload: {
  data: Array<ContactDetail>;
  licenseKey: string;
}) {
  const { data, licenseKey } = payload;
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/contact-details/${licenseKey}/`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function deleteContactDetails(
  payload: Array<number>,
  licenseKey: string
) {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/contact-details/${licenseKey}`,
    { timeout: 60000, params: { 'ids[]': payload.join(',') } }
  );
  return response;
}

export async function updateContactDetailList(
  payload: Array<{ id?: number; contact_details: ContactDetail }>,
  licenseKey: string
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/contact-details/${licenseKey}`,
    payload,
    { timeout: 60000 }
  );
  return response;
}

export async function createCustomAddress(payload: {
  data: Array<CustomAddress>;
  licenseKey: string;
}) {
  const { data, licenseKey } = payload;
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/dealer-custom-address/${licenseKey}`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function deleteCustomAddress(
  payload: Array<number>,
  licenseKey: string
) {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/dealer-custom-address/${licenseKey}`,
    { timeout: 60000, params: payload[0] === 0 ? { 'ids[]': [0], remove: 'true' } : { 'ids[]': payload.join(',') } }
  );
  return response;
}

export async function updateCustomAddressList(
  payload: Array<{ id?: number; dealer_addresses: CustomAddress }>,
  licenseKey: string
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/dealer-custom-address/${licenseKey}`,
    payload,
    { timeout: 60000 }
  );
  return response;
}

export async function editTransfer(
  id: string,
  transferDetails: CreateTransferPayload
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${id}`,
    transferDetails,
    { timeout: 30000 }
  );
  return response.data as Transfer;
}

export async function updateDefaultShippingAddress(
  licenseKey: string,
  defaultShippingAddress: DefaultShippingAddress
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/shipping-address/${licenseKey}`,
    defaultShippingAddress,
    { timeout: 30000 }
  );
  return response.data;
}

export async function createUser(data: CreateUserInterface) {
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/users`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function deleteUser(userName: string) {
  const response = await client.delete(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/users/${userName}`,
    { timeout: 60000 }
  );
  return response;
}

export async function editUser(data: EditUserInterface, userId: string) {
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/users/${userId}`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function getAllTransferList(params: TransferListResquestParams) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers`,
    {
      params,
      timeout: 60000
    }
  );
  return response.data as TransferList<Transfer>;
}

export async function changeShootingRange(data: { license_key: string }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/dealers/${data.license_key}/range`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function getSuggestedResult(searchQuery: string) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/search?full_license_key=${searchQuery}&sortBy=name`,
    { timeout: 30000 }
  );
  return response;
}

export async function updateTransferArchive(
  data: { isArchive: boolean },
  transferId: string
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${transferId}/archive`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function generateEncryption() {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/store/encryption-key`,
    { timeout: 60000 }
  );
  return response;
}

export async function removeEncryptionKeyApi() {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/store/encryption-key`,
    { timeout: 60000 }
  );
  return response;
}

export async function updateStoreConfigurationApi(data: StoreConfigForm) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/store/config`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function updateStoreFilterConfigApi(data: StoreFilterConfig) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/store/filter/config`,
    data,
    { timeout: 60000 }
  );
  return response;
}
export async function getFFLSelectConfiguration() {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/store/global-config`,
    { timeout: 60000 }
  );
  return response;
}

export async function getFFLExportLiveUserStatus(uuid: string){
    const data = {uuid}
    const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/ffl-export-live-users`,
      data,
    {timeout: 60000}
  );
  return response;
}

export async function updateSelectConfigurationApi(data: GlobalConfig) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/store/global-config`,
    data,
    { timeout: 60000 }
  );
  return response;
}

// Stripe Customer ID APIs
export async function getStripeCustomerId() {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/stripe-customer-id`,
    { timeout: 60000 }
  );
  return response;
}

export async function updateStripeCustomerId(data: { customer_id?: string; is_active?: boolean }) {
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/stripe-customer-id`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function inboundTransferActionApi(
  data: { action: string },
  transferId: string
) {
  const response = await client.put(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${transferId}/status`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function impersionateUser(data: { storeId: string }) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/admin/impersonation`,
    { storeId: data.storeId }
  );
  return response;
}

export async function transferDetailsApi(id: string) {
  const response = await client.get(
    // `${AppConfig.backOfficeApiBaseURL}/transfers/${id}`,
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/${id}`,
    { timeout: 60000 }
  );
  return response;
}
export async function getTransferFilters(){
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections?type=transferQueue&pageSize=50`,
    { timeout: 60000 }
  );
  return response;
}

export async function saveTransferFilterCollection(data: any){
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections`,
    {
      ...data,
      type: data?.type ?? 'transferQueue'
    },
    { timeout: 60000 }
  );
  return response;
}

export async function deleteTransferFilterCollection(collectionId: string) {
  const response = await client.delete(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections/${collectionId}`,
    { timeout: 60000 }
  );
  return response;
}

export interface DealerFilterCollectionPayload {
  id?: string;
  name: string;
  search_filters: Record<string, any>;
  is_default: boolean;
  type: string;
  kind?: 'save' | 'update';
}

export async function getDealerFilterCollections(type: string) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections`,
    {
      params: { type, pageSize: 50 },
      timeout: 60000
    }
  );
  return response;
}

export async function upsertDealerFilterCollection(payload: DealerFilterCollectionPayload) {
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections`,
    payload,
    { timeout: 60000 }
  );
  return response;
}

export async function deleteDealerFilterCollection(id: string) {
  const response = await client.delete(
    `${AppConfig.fflExpressServiceApiURL}/dealers/filter/collections/${id}`,
    { timeout: 60000 }
  );
  return response;
}

export async function saveTransferFilters(data: any){
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/filterPreferences`,
    data,
    { timeout: 60000 }
  );
  return response;
}

export async function removeTransferFilters(){
  const response = await client.delete(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/filterPreferences`,
    { timeout: 60000 }
  );
  return response;
}

export async function callAutoCompleteAPI(data: any) {
 const response = await client.get(
  `${AppConfig.fflExpressServiceApiURL}/dealers/select/search/auto-complete?query=${data.trim()}`,
  {timeout: 60000}
 );
 return response;
}

export async function exitImpersionateUser() {
  const response = await client.delete(
    `${AppConfig.backOfficeApiBaseURL}/admin/impersonation`,
    { timeout: 60000 }
  );
  return response;
}

export async function licenseDetailsApi(licenseId: string, params?: {}) {
  const response = await client.get(`${AppConfig.fflGetApiBaseURL}/licenses`, {
    timeout: 30000,
    params: { licenseId, ...params }
  });
  return response.data[0] as Licensee;
}
export async function licenseDetailsNewApi(licenseKey:string, params?:{}){
  const response = await client.get(`${AppConfig.fflExpressServiceApiURL}/dealers/search`, {
    timeout: 30000,
    params: { license_key:licenseKey, ...params }
  });
  return response.data.data[0] as LicenseDetail;
}
export async function resendIinitiationEmailAPI(transferId: string) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${transferId}/resend-initiation-email`,
    {
      timeout: 30000
    }
  );
  return response;
}
export async function generateTrasferMasterProof(transferId: string) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/transfers/${transferId}/re-generate-master-proof`,
    {timeout: 30000}
  );
  return response;
}
export async function resumeTransferApi(transferId: string) {
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/${transferId}/resume`,
    {},
    { timeout: 30000 }
  );
  return response;
}
export async function getDealerDetails(dealerId: string) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/profile?dealer_id=${dealerId}`,
    { timeout: 30000 }
  );
  return response;
}

export async function getTransferCount(dealer_id: string) {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/v2/completed-counts?dealer_id=${dealer_id}`,
    { timeout: 30000 }
  );
  return response;
}

export async function getDealerSignedPhotos(licenseKey: string) {
  const response = await client.get(
    `${AppConfig.fflGetApiBaseURL}/ffl/dealer/${licenseKey}/photos`,
    {
      timeout: 30000
    }
  );

  return response;
}

export async function assignTransferDealer(data: { transferId: string, licenseKey: string, reason?: string }) {
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/${data.transferId}/assign-dealer`,
    { licenseKey: data.licenseKey, reason: data?.reason || '' },
  )
  return response;
}

export async function getTransferDealerHistory(data: { transferId: string }) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/transfer-status/v2/${data.transferId}/dealer-history`,
  )
  return response;
}

export async function updateSOTStampPath (payload: any) {
  console.log("updateSOTStampPath : ", payload.licensePath);
  const encodedLicensePath = encodeURIComponent(payload.licensePath);
  console.log({encodedLicensePath});
   const response = await client.post(`${AppConfig.backOfficeApiBaseURL}/upload-sot-license/?licenseKey=${payload.licenseKey}&licensePath=${encodedLicensePath}&source=${payload.source}`);
   return response;
 }

export async function updateLOAPath (payload: any) {
  console.log("updateLOAPath : ", payload.licensePath);
  const encodedLicensePath = encodeURIComponent(payload.licensePath);
  console.log({encodedLicensePath});
  const response = await client.post(`${AppConfig.backOfficeApiBaseURL}/upload-loa-license/?licenseKey=${payload.licenseKey}&licensePath=${encodedLicensePath}&source=${payload.source}`);

  return response;
}

export async function getAllPreferredDealers(data: PreferredDealersMetaData) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/dealers/search?only_preferred_dealer=true&page_size=${data?.totalRecords}&page_number=${data?.pageNumber || 1}&include_opt_out_dealers=true&include_permanently_closed_dealers=true&include_big_box_retailer=true`,
    {timeout: 60000}
  )
  return response;
}

export async function sendEmailToCustomerAssignDealer(transferId: string) {
  const data = {
    id: transferId
  }
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/send-dealer-reassign-email`,
    data,
    { timeout: 30000 }
  );
  return response;
}

export async function onCallEmailNotFound(dealerId: string) {
  const response = await client.post(
    `${AppConfig.backOfficeApiBaseURL}/update-email-status/${dealerId}`,
    { timeout: 30000 }
  );
  return response;
}

export async function getDealerDocumentDetails(payload:any){
  const response = await client.get(`${AppConfig.fflExpressServiceApiURL}/dealers/details/document-status`, {
    timeout: 30000,
    params: payload
  });
  return response.data;
}

export async function getReAssignHistory(id: string) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/transfer-status/v2/${id}/reassignment-history`,
    { timeout: 60000 }
  );
  return response;
}

export async function getReAssignDealerHistory(payload: any) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/transfer-status/v2/${payload.transferId}/reassignment-history/${payload.reassignmentId}`,
    { timeout: 60000 }
  );
  return response;
}

export async function getPermissionsTabs(){
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/permissions`,
    { timeout: 60000 }
  );
  return response;
}

export async function savePermissions(data:any) {
  const response = await client.put(
    `${AppConfig.fflExpressServiceApiURL}/backend/stores/permissions`,
    data,
    { timeout: 30000 }
  );
  return response;
}


export async function getStoreList() {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/user-store/list`,
    { timeout: 30000 }
  );
  return response;
}

export async function getEcommerceStatusList() {
  const response = await client.get(
    `${AppConfig.backOfficeApiBaseURL}/transfers/ecommerce-status`
  );
  return response.data;
}

export async function onSkipMicroStep(transferId: string) {
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/skip-step/${transferId}`,
    {timeout: 30000})
  return response;
  }
export async function getEmailTamplate(payload: any) {
  const response = await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/email-template/${payload.emailId}`,
    { timeout: 60000 }
  );
  return response;
}
export const getOCRStepFunctionDetailsV2 = async (payload: any) =>
  await client.get(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/certificate/v2/${payload.clientDocumentId}`
  );

export const onManuallyRequestReview = async (data: { clientDocumentId: string }) =>
  await client.post(
    `${AppConfig.fflExpressServiceApiURL}/backend/transfers/manual-review-request/${data.clientDocumentId}`
  );

export const getReviewEmailTemaplete = async (payload: any) => {
  let data:any = {rejected_reason: payload.rejected_reason}
  if(payload?.note){
    data.note = payload.note
  }
return await client.post(
    `${AppConfig.backOfficeApiBaseURL}/manual-rejection/template/${payload.id}`,
    data
  );
}

export const sendReviewEmailTemaplete = async (payload: any) =>
  await client.post(
    `${AppConfig.backOfficeApiBaseURL}/manual-rejection/send/${payload.id}`,
    {
      rejected_reason: payload.rejected_reason,
      templateString: payload.templateString,
      subject: payload.subject,
    }
  );
export const getLicenseReviewDetailsById = async (payload: any) =>{
 return await client.get(
    `${AppConfig.backOfficeApiBaseURL}/certificate-history`,
    {params: {recordId: payload.id}}
  );
}
export const getSOTReviewDetailsById = async (payload: any) =>{
  return await client.get(
    `${AppConfig.backOfficeApiBaseURL}/upload-sot-list`,
    {params: {recordId: payload.id}}
  );
}
export const getLOAReviewDetailsById = async (payload: any) =>{
  return await client.get(
    `${AppConfig.backOfficeApiBaseURL}/upload-loa-list`,
    {params: {recordId: payload.id}}
  );
}


export async function getAllPreferredDealersByBackEnd(storeId: string) {
  const response = await client.post(
    `${AppConfig.fflExpressServiceApiURL}/dealers/admin/preferred-report`,
    // {storeId},
    {timeout: 60000}
  )
  return response;
}

export async function getCheckoutTokenDetails(payload: any) {
  return await client.get(`${AppConfig.fflGetApiBaseURL}/checkout/${payload.token}`, { timeout: 60000 });
}

export async function pushTracking(payload: TrackingInterface) {
  return await client.post(`${AppConfig.fflExpressServiceApiURL}/backend/misc/tracking`, payload, { timeout: 60000 });
}

/** String list from FFL Express misc API (e.g. status mapping dropdown). */
export interface MiscEcommerceStatusListResponse {
  success: boolean;
  data: string[];
  statusCode: number;
}

export async function getMiscEcommerceStatusList() {
  return client.get<MiscEcommerceStatusListResponse>(
    `${AppConfig.fflExpressServiceApiURL}/backend/misc/ecommerce-status-list`,
    { timeout: 30000 }
  );
}

export type EcommerceStatusActionMappingAction =
  | 'archive'
  | 'archive_and_notify_dealer'
  | 'unarchive';

/** Add: omit `id`. Edit: include `id`. Same endpoint uses PUT for both. */
export interface PutEcommerceStatusActionMappingBody {
  ecommerce_status: string;
  action: EcommerceStatusActionMappingAction;
  description: string;
  id?: string | number;
}

export async function putEcommerceStatusActionMapping(
  body: PutEcommerceStatusActionMappingBody
) {
  return client.put(
    `${AppConfig.fflExpressServiceApiURL}/dealers/ecommerce-status-action-mappings`,
    body,
    { timeout: 30000 }
  );
}

export async function deleteEcommerceStatusActionMapping(
  mappingId: string | number
) {
  const idSegment = encodeURIComponent(String(mappingId).trim());
  return client.delete(
    `${AppConfig.fflExpressServiceApiURL}/dealers/ecommerce-status-action-mappings/${idSegment}`,
    { timeout: 30000 }
  );
}
